<template>
    <div class="step-logs">
        <div class="log-box" ref="logbox">
            <div
                class="log-line"
                v-for="(log, i) in logs"
                :key="i"
                :ref="i == logs.length - 1 ? 'scrollToMe' : ''"
            >
                <p v-if="log.param == null">{{ '[' + log.time + '] ' }} {{ $t(log.message) }}</p>
                <p v-else>
                    {{ '[' + log.time + '] ' }} {{ $t(log.message, { n: log.param }) }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        images: {
            type: Array,
            default: () => [],
        },
        sendCancel: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            // logs: [{ message: 'msg-catalogo-log-finalizou-processamento', param: null, time: this.$moment().format("L LTS") }, { message: 'msg-catalogo-log-inicializando-processamento', param: null, time: this.$moment().format("L LTS") }, { message: 'msg-catalogo-log-enviando-n', param: '1500.jpg', time: this.$moment().format("L LTS") }, { message: 'msg-catalogo-log-enviado-n', param: '1500.jpg', time: this.$moment().format("L LTS") }],
            logs: [
                {
                    message: 'msg-catalogo-log-inicializando-processamento',
                    param: null,
                    time: this.$moment().format('L LTS'),
                },
            ],
            continueUploading: true,
        };
    },
    created() {
        this.permissao = this.hasPermissionAccess('vendas', 'produtos', 'ven-produto-catalogo');

        !this.permissao.read &&
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'catalogo' },
            });
    },
    watch: {
        sendCancel(val) {
            if (val) {
                this.cancelImageUploadProcess();
                this.$emit('sendCancel', false);
            }
        },
    },
    updated() {
        // whenever data changes and the component re-renders, this is called.
        this.$nextTick(() => this.scrollLog());
    },
    mounted() {
        this.sendData();
    },
    methods: {
        async sendData() {
            if (this.images && this.images.length > 0) {
                for (const element of this.images) {
                    if (this.continueUploading) {
                        try {
                            let img = element;
                            this.logs.push({
                                message: 'msg-catalogo-log-enviando-n',
                                param: img.originalName,
                                time: this.$moment().format('L LTS'),
                            });

                            const pacoteIds = img.pacote ? img.pacote.map(p => p.id) : 0
                            const catalogos = []

                            if (pacoteIds) {
                                pacoteIds.forEach(p => {
                                    let catalog = {
                                        fileName: img.fileName,
                                        originalName: img.originalName,
                                        assmediaproduto: {
                                            idproduto: img.produto.idproduto,
                                            idgradelinha: img.gradeLinha ? img.gradeLinha.id : 0,
                                            idgrade: img.gradeLinha ? img.gradeLinha.idgrade : 0,
                                        },
                                        destaque: img.destaque.value,
                                    };
                                    catalog.assmediaproduto.idpacote = p
                                    catalogos.push(catalog)
                                });
                            } else {
                                let catalog = {
                                        fileName: img.fileName,
                                        originalName: img.originalName,
                                        assmediaproduto: {
                                            idproduto: img.produto.idproduto,
                                            assmediaproduto: 0,
                                            idgradelinha: img.gradeLinha ? img.gradeLinha.id : 0,
                                            idgrade: img.gradeLinha ? img.gradeLinha.idgrade : 0,
                                        },
                                        destaque: img.destaque.value,
                                    };

                                    catalogos.push(catalog)
                            }

                            const data = new FormData();
                            data.append('file', img.file);
                            data.append('catalogo', new Blob([JSON.stringify(catalogos)], { type: "application/json" }));

                            await this.$axios.post('/sales/catalog', data, {
                                headers: {
                                    'Content-Type': undefined,
                                },
                            })
                            .then((r) => {
                                    if (r.data.content) {
                                        this.logs.push({
                                            message: 'msg-catalogo-log-enviado-n',
                                            param: img.originalName,
                                            time: this.$moment().format('L LTS'),
                                        });
                                    } else {
                                        this.logs.push({
                                            message: r.data.message,
                                            time: this.$moment().format('L LTS'),
                                        });
                                    }
                                })
                                .catch((e) => {
                                    if (e.data.message) {
                                        if (e.message.endsWith('-n')) {
                                            this.logs.push({
                                                message: e.data.message,
                                                param: img.originalName,
                                                time: this.$moment().format('L LTS'),
                                            });
                                        } else {
                                            this.logs.push({
                                                message: e.data.message,
                                                time: this.$moment().format('L LTS'),
                                            });
                                        }
                                    }
                                });
                        } catch (e) {
                            console.error('Erro: ', e);
                        }
                    } else {
                        this.$emit('isCanceling', false);
                        this.$emit('isFinished', true);
                    }
                }

                this.logs.push({
                    message: this.continueUploading
                        ? 'msg-catalogo-log-finalizou-processamento'
                        : 'msg-catalogo-log-cacelou-processamento',
                    param: null,
                    time: this.$moment().format('L LTS'),
                });
                // Envia as flags para o componente pai para dizer que acabou o upload e o usuário pode clicar em voltar.
                this.$emit('isCanceling', false);
                this.$emit('isFinished', true);
            }
        },
        cancelImageUploadProcess() {
            this.$root.confirm({
                message: this.$t('msg-cancel-upload'),
                onConfirm: this.cancel,
            });
        },
        cancel() {
            this.continueUploading = false;
        },
        scrollLog() {
            const el = this.$refs.logbox;
            if (el) {
                el.scrollTop = el.lastElementChild.offsetTop;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.step-logs {
    display: flex;
    width: 100%;
    height: 600px;
    justify-content: space-between;
    padding: 10px;
    padding: 0 10px;
    border: 1px solid $table-border;
    border-radius: 10px;

    .log-box {
        width: 100%;
        overflow: auto;

        .log-line {
            font-size: 14px;
            color: $sovis-black;
        }
    }
}
</style>
